import React from 'react';
import { SpinnerContainer, Spinner, LoadingText } from './LoadingSpinner.styles';

interface LoadingSpinnerProps {
    text?: string;
    size?: 'small' | 'medium' | 'large';
    centered?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ text = 'Loading...', size = 'medium', centered = true }) => {
    return (
        <SpinnerContainer centered={centered}>
            <Spinner size={size} />
            {text && <LoadingText>{text}</LoadingText>}
        </SpinnerContainer>
    );
};

export default LoadingSpinner;
